class LocalizationSelect extends HTMLFormElement {
  constructor() {
    super();

    this.select.addEventListener('change', this.onChange);
  }

  get select() {
    return this.querySelector('select');
  }

  get form() {
    return this
  }

  onChange() {
    if (this.value.includes('/')) {
      window.location.href = this.value;
    } else {
      this.form.submit();
    }
  }
}
customElements.define('localization-select', LocalizationSelect, { extends: 'form' });
class SBAsyncButton extends HTMLButtonElement {
  constructor() {
    super()

    if (this.type === 'submit' && this.form) {
      this.form.addEventListener('submit', () => this.setAttribute('aria-busy', 'true'))
    }

    window.addEventListener('pageshow', () => this.removeAttribute('aria-busy'))
    this.append(this.animationElement)
  }

  static get observedAttributes() {
    return ['aria-busy']
  }

  get contentElement() {
    return (this._contentElement = this._contentElement || this.querySelector('.btn-text'))
  }

  get animationElement() {
    return (this._animationElement =
      this._animationElement ||
      document.createRange().createContextualFragment(`
      <span class="btn-loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild)
  }

  async attributeChangedCallback(_name, _oldValue, newValue) {
    if (theme.config.isTouch || document.body.getAttribute('data-button_hover') === 'none') return

    if (newValue === 'true') {
      Motion.timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [this.animationElement, { opacity: 1 }, { duration: 0.15 }],
      ])
      Motion.animate(
        this.animationElement.children,
        { transform: ['scale(1.6)', 'scale(0.6)'] },
        { duration: 0.35, delay: Motion.stagger(0.35 / 2), direction: 'alternate', repeat: Infinity }
      )
    } else {
      Motion.timeline([
        [this.animationElement, { opacity: 0 }, { duration: 0.15 }],
        [this.contentElement, { opacity: 1 }, { duration: 0.15 }],
      ])
    }
  }
}
customElements.define('sb-async-button', SBAsyncButton, { extends: 'button' })

class SBCookiebotToggle extends HTMLButtonElement {
  constructor() {
    super()

    this.addEventListener('click', this.toggle.bind(this))
  }

  toogleCMP() {
    const e = document.querySelectorAll('html > body div#CookiebotWidget')[0]

    if (e) {
      const ee = e.querySelectorAll('button[class^="CookiebotWidget-logo')[0]

      if (ee) {
        ee.click()
        return true
      }
    }

    return false
  }

  toggle() {
    if (!this.toogleCMP()) {
      if (window.Cookiebot) {
        window.Cookiebot.renew()
      }
    }
  }
}
customElements.define('sb-cookiebot-toggle', SBCookiebotToggle, { extends: 'button' })

function trackCTAClick(eventName, source, click_item_name, click_item_id) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    "event": eventName,
    "click_source": source,
    "click_item_name": click_item_name,
    "click_item_id": click_item_id
  })
}